var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '../../Components/ComponentModal';
import PageBasic from './Create/PageBasic';
import PageAdditional from './Create/PageAdditional';
import PageAttachments from './Create/PageAttachments';
import { toggleModal } from '../../Actions';
import T from '../../Locale';
import { saveValue } from './Actions';
const initialState = { data: { type: 'value' }, isPristine: true, page: 1 };
class ComponentModalCreate extends Component {
    constructor(props) {
        super(props);
        const { data } = this.props;
        this.state = { isPristine: true, page: 1, data };
        this.setData = this.setData.bind(this);
        this.save = this.save.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);
        this.close = this.close.bind(this);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        // If editing an item, set it as data.
        if (nextProps.data) {
            this.setState({ data: nextProps.data });
        }
    }
    setData(key, value) {
        const { data } = Object.assign({}, this.state);
        if (value !== null) {
            data[key] = value;
        }
        else {
            delete data[key];
        }
        this.setState(Object.assign(Object.assign({}, data), { isPristine: false }));
    }
    save(image, documentation) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = this.state;
            const { dispatch } = this.props;
            yield dispatch(saveValue(data, image, documentation));
            dispatch(toggleModal());
            this.setState(initialState);
        });
    }
    goToNextPage() {
        const { page } = this.state;
        this.setState({ page: page + 1 });
    }
    goToPreviousPage() {
        const { page } = this.state;
        this.setState({ page: page - 1 });
    }
    close() {
        const { dispatch } = this.props;
        const { isPristine } = this.state;
        // Always reset pager.
        this.setState({ page: 1 });
        // Display a warning that all inputted data will be lost.
        if (!isPristine && window.confirm(T.translate('values.warning'))) {
            dispatch(toggleModal());
            this.setState(initialState);
        }
        else if (isPristine) {
            dispatch(toggleModal());
        }
    }
    render() {
        const { data, page } = this.state;
        return (_jsxs(Modal, Object.assign({ modalKey: "create-value", onClose: this.close }, { children: [page === 1 && (_jsx(PageBasic, { data: data, goToNextPage: this.goToNextPage, setData: this.setData })), page === 2 && (_jsx(PageAdditional, { data: data, goToNextPage: this.goToNextPage, goToPreviousPage: this.goToPreviousPage, setData: this.setData })), page === 3 && (_jsx(PageAttachments, { data: data, goToPreviousPage: this.goToPreviousPage, setData: this.setData, save: this.save }))] })));
    }
}
ComponentModalCreate.propTypes = {
    dispatch: PropTypes.func.isRequired,
    data: PropTypes.object
};
ComponentModalCreate.defaultProps = { data: { type: 'value' } };
const mapStateToProps = (state) => ({ data: state.values.itemToEdit });
export default connect(mapStateToProps)(ComponentModalCreate);
